import Joi from 'joi';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

class CustomETReportForm extends Form {
	state = {
		data: {
			ndeTechnique: '',
			equipment: '',
			probe: '',
			material: '',
			probeFrequency: '',
			scanningLevel: '',
			serialNo: '',
			calibrationBlk: '',
			sensitivity: '',
			calibrationDue: new Date(),
			remarks: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		ndeTechnique: Joi.string().min(3).required().label('NDE Technique'),
		equipment: Joi.string().min(3).required().label('Equipment'),
		probe: Joi.string().min(3).required().label('Probe'),
		material: Joi.string().min(3).required().label('Material'),
		probeFrequency: Joi.string().min(3).required().label('Probe Frequency'),
		calibrationBlk: Joi.string().min(3).required().label('Calibration BLK'),
		sensitivity: Joi.string().min(3).required().label('Sensitivity'),
		serialNo: Joi.string().min(3).required().label('Serial Number'),
		scanningLevel: Joi.string().min(3).required().label('Scanning Level'),
		calibrationDue: Joi.date()
			.greater('now')
			.required()
			.label('Calibration Due Date'),
		remarks: Joi.string().min(0).required().label('Remarks'),
	};

	static propTypes = {
		initialData: PropTypes.object,
		onProceed: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialData) {
			this.setState({ data: _.omit(this.props.initialData, ['procedureNo', 'inspectionStd', 'acceptanceCriteria']) });
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data);
		toastService.success('ET Report Data Saved!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'ndeTechnique',
							label: 'NDE Technique',
							placeholder: 'Enter NDE Technique',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'equipment',
							label: 'Equipment',
							placeholder: 'e.g. Enter Equipment',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderDatePicker({
							name: 'calibrationDue',
							label: 'Calibration Due Date',
							placeholderText: 'Select Calibration Due Date',
							minDate: new Date(),
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'probe',
							label: 'Probe',
							placeholder: 'Enter Probe',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'calibrationBlk',
							label: 'Calibration Blk',
							placeholder: 'Enter Calibration Blk',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				{this.renderInput({
					type: 'text',
					name: 'material',
					label: 'Material',
					placeholder: 'Enter Material',
				})}

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'probeFrequency',
							label: 'Probe Frequency',
							placeholder: 'Enter Probe Frequency',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'sensitivity',
							label: 'Sensitivity',
							placeholder: 'Enter Sensitivity',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'serialNo',
							label: 'Serial Number',
							placeholder: 'Enter Serial Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'scanningLevel',
							label: 'Scanning Level',
							placeholder: 'Enter Scanning Level',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				{this.renderTextEditor({
					name: 'remarks',
					placeholder: 'Enter Remark',
					label: 'Remark',
				})}

				<div className="divider my-4"></div>

				{this.renderButton('Submit Overview')}
			</form>
		);
	}
}

export default CustomETReportForm;
